<template lang="pug">
.rating-place
  .rating-place__date {{ date }}
  .rating-place__grid
    RatingNumber(:type="type", :number="place")
    RatingCard(
      v-for="(card, card_index) in ratingCards",
      :key="card_index",
      :className="getClassName(card.classCode)",
      :nickname="card.pcName",
      :serverName="card.shardName"
    )

</template>

<script>
import classes_map from "./data/classes_map.js";

import RatingNumber from "./RatingNumber";
import RatingCard from "./RatingCard";

export default {
  name: "RatingPlace",
  components: {
    RatingNumber,
    RatingCard,
  },
  props: {
    type: {
      type: String,
      default: "bronze",
    },
    place: {
      type: Number,
      default: 9,
    },
    date: {
      type: String,
      default: "",
    },
    rating: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      numberCards: 8,
    }
  },
  computed: {
    ratingCards() {
      return Array.from({ length: this.numberCards }, (value, index) => this.rating[index] || {});
    },
  },
  methods: {
    getClassName(class_code) {
      return classes_map.hasOwnProperty(class_code) ? classes_map[class_code] : "";
    },
  },
};
</script>
